import { CHAIN_TO_ADDRESSES_MAP, ChainId, Token } from '@uniswap/sdk-core';
import { FACTORY_ADDRESS } from '@uniswap/v3-sdk';

import { NETWORKS_WITH_SAME_UNISWAP_ADDRESSES } from './chains';

export const BNB_TICK_LENS_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].tickLensAddress;
export const BNB_NONFUNGIBLE_POSITION_MANAGER_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].nonfungiblePositionManagerAddress;
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const BNB_SWAP_ROUTER_02_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].swapRouter02Address!;
export const BNB_V3_MIGRATOR_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].v3MigratorAddress;

export const V3_CORE_FACTORY_ADDRESSES: AddressMap = {
  ...constructSameAddressMap(FACTORY_ADDRESS),
  [ChainId.CELO]: CHAIN_TO_ADDRESSES_MAP[ChainId.CELO].v3CoreFactoryAddress,
  [ChainId.CELO_ALFAJORES]: CHAIN_TO_ADDRESSES_MAP[ChainId.CELO_ALFAJORES].v3CoreFactoryAddress,
  [ChainId.OPTIMISM_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.OPTIMISM_GOERLI].v3CoreFactoryAddress,
  [ChainId.SEPOLIA]: CHAIN_TO_ADDRESSES_MAP[ChainId.SEPOLIA].v3CoreFactoryAddress,
  [ChainId.ARBITRUM_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.ARBITRUM_GOERLI].v3CoreFactoryAddress,
  [ChainId.BNB]: CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].v3CoreFactoryAddress,
  [ChainId.AVALANCHE]: CHAIN_TO_ADDRESSES_MAP[ChainId.AVALANCHE].v3CoreFactoryAddress,
  [ChainId.BASE_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.BASE_GOERLI].v3CoreFactoryAddress,
  [ChainId.BASE]: CHAIN_TO_ADDRESSES_MAP[ChainId.BASE].v3CoreFactoryAddress,
  [ChainId.DBK]: CHAIN_TO_ADDRESSES_MAP[ChainId.DBK].v3CoreFactoryAddress,
  [ChainId.BERACHAIN]: CHAIN_TO_ADDRESSES_MAP[ChainId.BERACHAIN].v3CoreFactoryAddress,
  [ChainId.HYPERLIQUID]: CHAIN_TO_ADDRESSES_MAP[ChainId.HYPERLIQUID].v3CoreFactoryAddress,
  [ChainId.SONIC]: CHAIN_TO_ADDRESSES_MAP[ChainId.SONIC].v3CoreFactoryAddress,
  [ChainId.KATANA]: CHAIN_TO_ADDRESSES_MAP[ChainId.KATANA].v3CoreFactoryAddress,
  [ChainId.MITOSIS]: CHAIN_TO_ADDRESSES_MAP[ChainId.MITOSIS].v3CoreFactoryAddress,
  [ChainId.SOMNIA]: CHAIN_TO_ADDRESSES_MAP[ChainId.SOMNIA].v3CoreFactoryAddress,
  [ChainId.ZEROG]: CHAIN_TO_ADDRESSES_MAP[ChainId.ZEROG].v3CoreFactoryAddress,
  [ChainId.PLASMA]: CHAIN_TO_ADDRESSES_MAP[ChainId.PLASMA].v3CoreFactoryAddress,
  [ChainId.MONAD_TESTNET]: CHAIN_TO_ADDRESSES_MAP[ChainId.MONAD_TESTNET].v3CoreFactoryAddress,
  [ChainId.MONAD]: CHAIN_TO_ADDRESSES_MAP[ChainId.MONAD].v3CoreFactoryAddress,
  [ChainId.MEGAETH]: CHAIN_TO_ADDRESSES_MAP[ChainId.MEGAETH].v3CoreFactoryAddress,
  [ChainId.STABLE]: CHAIN_TO_ADDRESSES_MAP[ChainId.STABLE].v3CoreFactoryAddress,
  // TODO: Gnosis + Moonbeam contracts to be deployed
};

export const QUOTER_V2_ADDRESSES: AddressMap = {
  ...constructSameAddressMap('0x61fFE014bA17989E743c5F6cB21bF9697530B21e'),
  [ChainId.CELO]: CHAIN_TO_ADDRESSES_MAP[ChainId.CELO].quoterAddress,
  [ChainId.CELO_ALFAJORES]: CHAIN_TO_ADDRESSES_MAP[ChainId.CELO_ALFAJORES].quoterAddress,
  [ChainId.OPTIMISM_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.OPTIMISM_GOERLI].quoterAddress,
  [ChainId.SEPOLIA]: CHAIN_TO_ADDRESSES_MAP[ChainId.SEPOLIA].quoterAddress,
  [ChainId.ARBITRUM_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.ARBITRUM_GOERLI].quoterAddress,
  [ChainId.BNB]: CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].quoterAddress,
  [ChainId.AVALANCHE]: CHAIN_TO_ADDRESSES_MAP[ChainId.AVALANCHE].quoterAddress,
  [ChainId.BASE_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.BASE_GOERLI].quoterAddress,
  [ChainId.BASE]: CHAIN_TO_ADDRESSES_MAP[ChainId.BASE].quoterAddress,
  [ChainId.DBK]: CHAIN_TO_ADDRESSES_MAP[ChainId.DBK].quoterAddress,
  [ChainId.BERACHAIN]: CHAIN_TO_ADDRESSES_MAP[ChainId.BERACHAIN].quoterAddress,
  [ChainId.HYPERLIQUID]: CHAIN_TO_ADDRESSES_MAP[ChainId.HYPERLIQUID].quoterAddress,
  [ChainId.SONIC]: CHAIN_TO_ADDRESSES_MAP[ChainId.SONIC].quoterAddress,
  [ChainId.KATANA]: CHAIN_TO_ADDRESSES_MAP[ChainId.KATANA].quoterAddress,
  [ChainId.MITOSIS]: CHAIN_TO_ADDRESSES_MAP[ChainId.MITOSIS].quoterAddress,
  [ChainId.SOMNIA]: CHAIN_TO_ADDRESSES_MAP[ChainId.SOMNIA].quoterAddress,
  [ChainId.ZEROG]: CHAIN_TO_ADDRESSES_MAP[ChainId.ZEROG].quoterAddress,
  [ChainId.PLASMA]: CHAIN_TO_ADDRESSES_MAP[ChainId.PLASMA].quoterAddress,
  [ChainId.MONAD_TESTNET]: CHAIN_TO_ADDRESSES_MAP[ChainId.MONAD_TESTNET].quoterAddress,
  [ChainId.MONAD]: CHAIN_TO_ADDRESSES_MAP[ChainId.MONAD].quoterAddress,
  [ChainId.MEGAETH]: CHAIN_TO_ADDRESSES_MAP[ChainId.MEGAETH].quoterAddress,
  [ChainId.STABLE]: CHAIN_TO_ADDRESSES_MAP[ChainId.STABLE].quoterAddress,
  // TODO: Gnosis + Moonbeam contracts to be deployed
};

export const MIXED_ROUTE_QUOTER_V1_ADDRESSES: AddressMap = {
  [ChainId.MAINNET]: CHAIN_TO_ADDRESSES_MAP[ChainId.MAINNET].v1MixedRouteQuoterAddress,
  [ChainId.GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.GOERLI].v1MixedRouteQuoterAddress,
};

export const UNISWAP_MULTICALL_ADDRESSES: AddressMap = {
  ...constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984'),
  [ChainId.CELO]: CHAIN_TO_ADDRESSES_MAP[ChainId.CELO].multicallAddress,
  [ChainId.CELO_ALFAJORES]: CHAIN_TO_ADDRESSES_MAP[ChainId.CELO_ALFAJORES].multicallAddress,
  [ChainId.OPTIMISM_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.OPTIMISM_GOERLI].multicallAddress,
  [ChainId.SEPOLIA]: CHAIN_TO_ADDRESSES_MAP[ChainId.SEPOLIA].multicallAddress,
  [ChainId.ARBITRUM_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.ARBITRUM_GOERLI].multicallAddress,
  [ChainId.BNB]: CHAIN_TO_ADDRESSES_MAP[ChainId.BNB].multicallAddress,
  [ChainId.AVALANCHE]: CHAIN_TO_ADDRESSES_MAP[ChainId.AVALANCHE].multicallAddress,
  [ChainId.BASE_GOERLI]: CHAIN_TO_ADDRESSES_MAP[ChainId.BASE_GOERLI].multicallAddress,
  [ChainId.BASE]: CHAIN_TO_ADDRESSES_MAP[ChainId.BASE].multicallAddress,
  [ChainId.DBK]: CHAIN_TO_ADDRESSES_MAP[ChainId.DBK].multicallAddress,
  [ChainId.BERACHAIN]: CHAIN_TO_ADDRESSES_MAP[ChainId.BERACHAIN].multicallAddress,
  [ChainId.HYPERLIQUID]: CHAIN_TO_ADDRESSES_MAP[ChainId.HYPERLIQUID].multicallAddress,
  [ChainId.SONIC]: CHAIN_TO_ADDRESSES_MAP[ChainId.SONIC].multicallAddress,
  [ChainId.KATANA]: CHAIN_TO_ADDRESSES_MAP[ChainId.KATANA].multicallAddress,
  [ChainId.MITOSIS]: CHAIN_TO_ADDRESSES_MAP[ChainId.MITOSIS].multicallAddress,
  [ChainId.SOMNIA]: CHAIN_TO_ADDRESSES_MAP[ChainId.SOMNIA].multicallAddress,
  [ChainId.ZEROG]: CHAIN_TO_ADDRESSES_MAP[ChainId.ZEROG].multicallAddress,
  [ChainId.PLASMA]: CHAIN_TO_ADDRESSES_MAP[ChainId.PLASMA].multicallAddress,
  [ChainId.MONAD_TESTNET]: CHAIN_TO_ADDRESSES_MAP[ChainId.MONAD_TESTNET].multicallAddress,
  [ChainId.MONAD]: CHAIN_TO_ADDRESSES_MAP[ChainId.MONAD].multicallAddress,
  [ChainId.MEGAETH]: CHAIN_TO_ADDRESSES_MAP[ChainId.MEGAETH].multicallAddress,
  [ChainId.STABLE]: CHAIN_TO_ADDRESSES_MAP[ChainId.STABLE].multicallAddress,
  // TODO: Gnosis + Moonbeam contracts to be deployed
};

export const SWAP_ROUTER_02_ADDRESSES = (chainId: number) : string => {
  if (chainId == ChainId.BNB) {
    return BNB_SWAP_ROUTER_02_ADDRESS;
  }
  return '0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45';
};

export const OVM_GASPRICE_ADDRESS =
  '0x420000000000000000000000000000000000000F';
export const ARB_GASINFO_ADDRESS = '0x000000000000000000000000000000000000006C';
export const TICK_LENS_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.ARBITRUM_ONE].tickLensAddress;
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.MAINNET].nonfungiblePositionManagerAddress;
export const V3_MIGRATOR_ADDRESS = CHAIN_TO_ADDRESSES_MAP[ChainId.MAINNET].v3MigratorAddress;
export const MULTICALL2_ADDRESS = '0xB00B044d2fdE62c781e676Bb62938383b5393518';

export type AddressMap = { [chainId: number]: string | undefined };

export function constructSameAddressMap<T extends string>(
  address: T,
  additionalNetworks: ChainId[] = []
): { [chainId: number]: T } {
  return NETWORKS_WITH_SAME_UNISWAP_ADDRESSES.concat(
    additionalNetworks
  ).reduce<{
    [chainId: number]: T;
  }>((memo, chainId) => {
    memo[chainId] = address;
    return memo;
  }, {});
}

export const WETH9: {
  [chainId in Exclude<
    ChainId,
    | ChainId.POLYGON
    | ChainId.POLYGON_MUMBAI
    | ChainId.CELO
    | ChainId.CELO_ALFAJORES
    | ChainId.GNOSIS
    | ChainId.MOONBEAM
    | ChainId.BNB
    | ChainId.AVALANCHE
    // TODO: check if this shit actually should include some chains like bera, hyperliquid, sonic, mitosis...
  >]: Token;
} = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.GOERLI]: new Token(
    ChainId.GOERLI,
    '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.SEPOLIA]: new Token(
    ChainId.SEPOLIA,
    '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.OPTIMISM]: new Token(
    ChainId.OPTIMISM,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.OPTIMISM_GOERLI]: new Token(
    ChainId.OPTIMISM_GOERLI,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.ARBITRUM_ONE]: new Token(
    ChainId.ARBITRUM_ONE,
    '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.ARBITRUM_GOERLI]: new Token(
    ChainId.ARBITRUM_GOERLI,
    '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.BASE_GOERLI]: new Token(
    ChainId.BASE_GOERLI,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.BASE]: new Token(
    ChainId.BASE,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.DBK]: new Token(
    ChainId.DBK,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.BERACHAIN]: new Token(
    ChainId.BERACHAIN,
    '0x6969696969696969696969696969696969696969',
    18,
    'WBERA',
    'Wrapped BERA'
  ),
  [ChainId.HYPERLIQUID]: new Token(
    ChainId.HYPERLIQUID,
    '0x5555555555555555555555555555555555555555',
    18,
    'WHYPE',
    'Wrapped Hype'
  ),
  [ChainId.SONIC]: new Token(
    ChainId.SONIC,
    '0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38',
    18,
    'WS',
    'Wrapped Sonic'
  ),
  [ChainId.KATANA]: new Token(
    ChainId.KATANA,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.MITOSIS]: new Token(
    ChainId.MITOSIS,
    '0x124816325006f97E7136942B134a9545D95b05Fa',
    18,
    'WMITO',
    'Wrapped Mitosis'
  ),
  [ChainId.SOMNIA]: new Token(
    ChainId.SOMNIA,
    '0x046EDe9564A72571df6F5e44d0405360c0f4dCab',
    18,
    'WSOMI',
    'Wrapped Somnia'
  ),
  [ChainId.ZEROG]: new Token(
    ChainId.ZEROG,
    '0x1Cd0690fF9a693f5EF2dD976660a8dAFc81A109c',
    18,
    'W0G',
    'Wrapped 0G'
  ),
  [ChainId.PLASMA]: new Token(
    ChainId.PLASMA,
    '0x6100E367285b01F48D07953803A2d8dCA5D19873',
    18,
    'WXPL',
    'Wrapped Plasma'
  ),
  [ChainId.MONAD_TESTNET]: new Token(
    ChainId.MONAD_TESTNET,
    '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701',
    18,
    'WMON',
    'Wrapped MON'
  ),
  [ChainId.MONAD]: new Token(
    ChainId.MONAD,
    '0x3bd359C1119dA7Da1D913D1C4D2B7c461115433A',
    18,
    'WMON',
    'Wrapped MON'
  ),
  [ChainId.MEGAETH]: new Token(
    ChainId.MEGAETH,
    '0x4200000000000000000000000000000000000006',
    18,
    'WETH',
    'Wrapped Ether'
  ),
  [ChainId.STABLE]: new Token(
    ChainId.STABLE,
    '0x817997Ca8394E26CCE3dE3A076a4889b27DbF9dE',
    18,
    'WgUSDT',
    'Wrapped gUSDT'
  ),
};
